import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserClock, faUserTie, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import CustomAvatar from './../components/customAvatar';
import { createReminder, getClient, getClients, getCandidates, getContacts, getDashboard } from './../API';
import { message, Input, Card, Spin, TimePicker, Tag, Row, Col, Select, Form, Modal, Button, Icon } from 'antd';
import { allLocations } from './../utils/invoices';
import { flexCenterRight, formItemLayoutReminder } from './../theme';
const { Option } = Select;
const { TextArea } = Input;

const format = 'HH:mm';

function CreateReminderForm({form, showReminderModal, reminderDate, handleOnClose}) {
  const dispatch = useDispatch();

  const session = useMappedState(state => state.session);
  const { getFieldDecorator } = form;

  const [creating, setCreating] = useState(false);
  const [initLoading, setInitLoading] = useState(false);
  const [clientLoading, setClientLoading] = useState(false);

  const [clients, setClients] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [allContacts, setAllContacts] = useState([]);

  const [panel, setPanel] = useState('select-reminder');

  useEffect(() => {
    async function fetchData() {
      setInitLoading(true);
      const responseClients = await getClients(session.authToken);
      setClients(responseClients.data.clients);

      const responseCandidates = await getCandidates(session.authToken);
      setCandidates(responseCandidates.data.candidates);

      const responseContacts = await getContacts(session.authToken);
      setAllContacts(responseContacts.data.contacts);

      setInitLoading(false);
    }
    fetchData();
  // eslint-disable-next-line
  }, []);

  const renderPanel = () => {
    switch(panel) {
      case 'select-reminder':
        return renderSelectReminder();
      case 'interview':
        return renderInterviewPanel();
      case 'candidate':
        return renderCandidatePanel();
      case 'contact':
        return renderContactPanel();
      case 'link-global':
        return renderLinkGlobalPanel();
      default:
        return null;
    }
  }

  const renderSelectReminder = () => {
    const gridStyle = {
      width: '25%',
      textAlign: 'center',
      cursor: 'pointer',
    };

    return(
      <div style={{height: '70px'}}>
        <Card.Grid style={gridStyle} onClick={() => {
          setPanel('link-global');
        }}>
          <FontAwesomeIcon icon={faUser} style={{color: '#DE5D83'}} />&nbsp;New Link-Global Reminder
        </Card.Grid>
        <Card.Grid style={gridStyle} onClick={() => {
          setPanel('interview');
        }}>
          <FontAwesomeIcon icon={faUserClock} style={{color: '#f759ab'}} />&nbsp;New Interview Reminder
        </Card.Grid>
        <Card.Grid style={gridStyle} onClick={() => {
          setPanel('candidate');
        }}>
          <FontAwesomeIcon icon={faUserTie} style={{color: '#1E90FF'}} />&nbsp;New Candidate Reminder
        </Card.Grid>
        <Card.Grid style={gridStyle} onClick={() => {
          setPanel('contact');
        }}>
          <FontAwesomeIcon icon={faUserCircle} style={{color: '#B284BE'}} />&nbsp;New Contact Reminder
        </Card.Grid>
      </div>
    )
  }

  const renderLinkGlobalPanel = () => {
    return(
      <Row>
        <Col span={24}>
        <Form.Item label="">
          {getFieldDecorator('notes', {
          })(
            <TextArea placeholder="Write Notes Here" style={{resize: 'none'}} rows={2} autoComplete="off" disabled={creating} />
          )}
        </Form.Item>
        </Col>
      </Row>
    )
  }

  const renderContactPanel = () => {
    return(
      <>
      <Row>
        <Col span={10}>
          <Form.Item {...formItemLayoutReminder} label="Contact">
            {getFieldDecorator('contact', {
              rules: [{ required: true, message: 'Please select contact!' }],
            })(
              <Select
                disabled={creating}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select contact"
                style={{ width: '100%' }}
              >
                {
                  allContacts.map((i) => (
                    <Option 
                      label={`${i.firstname} ${i.lastname}`} 
                      key={i.id} 
                      value={i.id}>
                      <CustomAvatar
                        colourCode={i.firstname.charAt(0).toLowerCase()}
                        char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                        charSize={11}
                        size={26}
                        src={i.avatar}
                      />
                      &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                      &nbsp;
                      <Tag>{i.client.name}</Tag>
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
        <Form.Item label="">
          {getFieldDecorator('notes', {
          })(
            <TextArea placeholder="Write Notes Here" style={{resize: 'none'}} rows={2} autoComplete="off" disabled={creating} />
          )}
        </Form.Item>
        </Col>
      </Row>
      </>
    )
  }

  const renderCandidatePanel = () => {
    return(
      <>
        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Candidate">
              {getFieldDecorator('candidate', {
                rules: [{ required: true, message: 'Please select candidate!' }],
              })(
                <Select
                  disabled={creating}
                  optionFilterProp={'label'}
                  showSearch={true}
                  placeholder="Select candidate"
                  style={{ width: '100%' }}
                >
                  {
                    candidates.map((i) => (
                      <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                        <CustomAvatar
                          colourCode={i.firstname.charAt(0).toLowerCase()}
                          char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                          charSize={11}
                          size={26}
                          src={i.avatar}
                        />
                        &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
          <Form.Item label="">
            {getFieldDecorator('notes', {
            })(
              <TextArea placeholder="Write Notes Here" style={{resize: 'none'}} rows={2} autoComplete="off" disabled={creating} />
            )}
          </Form.Item>
          </Col>
        </Row>
      </>
    )
  }

  const renderInterviewPanel = () => {
    return(
      <>
        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Client">
              {getFieldDecorator('client', {
                rules: [{ required: true, message: 'Please select client!' }],
              })(
                <Select
                  disabled={creating}
                  optionFilterProp={'label'}
                  showSearch={true}
                  placeholder="Select client"
                  style={{ width: '100%' }}
                  onChange={async (value) => {
                      setClientLoading(true);

                      // reset contact input
                      form.setFieldsValue({
                        contact: undefined,
                      });

                      const response = await getClient(session.authToken, value);
                      setContacts(response.data.client.contacts);
                      setClientLoading(false);
                  }}
                >
                  {
                    clients.map((i) => (
                      <Option label={i.name} key={i.id} value={i.id}>
                        <CustomAvatar
                          colourCode={i.name.charAt(0).toLowerCase()}
                          char={i.name.charAt(0).toUpperCase()}
                          charSize={11}
                          size={26}
                          src={i.avatar}
                        />
                        &nbsp;&nbsp;{i.name}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Contact">
              {getFieldDecorator('contact', {
                rules: [{ required: true, message: 'Please select contact!' }],
              })(
                <div>
                  {
                    clientLoading ? (
                      <div>&nbsp;&nbsp;<Icon type="loading" />&nbsp;Loading...</div>
                    ) : (
                      <Select
                          disabled={creating}
                          optionFilterProp={'label'}
                          showSearch={true}
                          placeholder="Select contact"
                          style={{ width: '100%' }}
                          onChange={(value) => {
                            form.setFieldsValue({
                              contact: value,
                            });
                          }}
                        >
                          {
                            contacts.map((i) => (
                              <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                                <CustomAvatar
                                  colourCode={i.firstname.charAt(0).toLowerCase()}
                                  char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                                  charSize={11}
                                  size={26}
                                  src={i.avatar}
                                />
                                &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                              </Option>
                            ))
                          }
                        </Select>
                    )
                  }
                </div>
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Candidate">
              {getFieldDecorator('candidate', {
                rules: [{ required: true, message: 'Please select candidate!' }],
              })(
                <Select
                  disabled={creating}
                  optionFilterProp={'label'}
                  showSearch={true}
                  placeholder="Select candidate"
                  style={{ width: '100%' }}
                >
                  {
                    candidates.map((i) => (
                      <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                        <CustomAvatar
                          colourCode={i.firstname.charAt(0).toLowerCase()}
                          char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                          charSize={11}
                          size={26}
                          src={i.avatar}
                        />
                        &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Location">
              {getFieldDecorator('location', {
                rules: [{ required: true, message: 'Please select location!' }],
              })(
                <Select
                  disabled={creating}
                  showSearch={true}
                  placeholder="Select location"
                  style={{ width: '100%' }}
                >
                  {
                    allLocations.map((i) => (
                      <Option key={i} value={i}>
                        {i}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayoutReminder} label="Location Time">
              {getFieldDecorator('locationTime', {
                rules: [{ required: true, message: 'Please select location time!' }],
              })(
                <TimePicker 
                  disabled={creating}
                  format={format} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={1} />
          <Col span={23}>
          <Form.Item label="">
            {getFieldDecorator('notes', {
            })(
              <TextArea placeholder="Write Notes Here" style={{resize: 'none'}} rows={2} autoComplete="off" disabled={creating} />
            )}
          </Form.Item>
          </Col>
        </Row>
      </>
    )
  }

  const displayTitle = () => {
    const base = `Create Reminder on ${moment(reminderDate).format('YYYY-MM-DD')}`;
    if (panel === 'interview') {
      return (
        <Row>
          <Col span={12}>
            {base}
          </Col>
          <Col span={12} style={flexCenterRight}>
            <Tag color="#f759ab" ><span><FontAwesomeIcon icon={faUserClock} /> Interview</span></Tag>
          </Col>
        </Row>
      )
    }
    if (panel === 'candidate') {
      return (
        <Row>
          <Col span={12}>
            {base}
          </Col>
          <Col span={12} style={flexCenterRight}>
            <Tag color="#1E90FF" ><span><FontAwesomeIcon icon={faUserTie} /> Candidate</span></Tag>
          </Col>
        </Row>
      )
    }
    if (panel === 'contact') {
      return (
        <Row>
          <Col span={12}>
            {base}
          </Col>
          <Col span={12} style={flexCenterRight}>
            <Tag color="#B284BE" ><span><FontAwesomeIcon icon={faUserCircle} /> Contact</span></Tag>
          </Col>
        </Row>
      )
    }
    if (panel === 'link-global') {
      return (
        <Row>
          <Col span={12}>
            {base}
          </Col>
          <Col span={12} style={flexCenterRight}>
            <Tag color="#DE5D83" ><span><FontAwesomeIcon icon={faUser} /> Link-Global</span></Tag>
          </Col>
        </Row>
      )
    }
    return base;
  };

  return (
    <Modal
      centered={true}
      title={displayTitle()}
      closable={false}
      visible={showReminderModal}
      width="90%"
      footer={[
        <Button 
          disabled={creating}
          key="close" onClick={handleOnClose}>
          <Icon type="close" />
          Close
        </Button>,
        <Button
          disabled={panel === 'select-reminder'}
          type="primary" key="create" onClick={async () => {
            const formResult = await form.validateFields();
            setCreating(true);

            let reminderParam = {
              type: panel,
              notes: formResult.notes,
            };

            if (panel === 'interview') {
              const localTime = `${moment(reminderDate).format('YYYY-MM-DD')} ${moment(formResult.locationTime).format('HH:mm')}:00`;
              reminderParam = {
                ...reminderParam,
                ...{
                  client: formResult.client,
                  contact: formResult.contact,
                  candidate: formResult.candidate,
                  location: formResult.location,
                  reminderDate: localTime,
                }
              }
            }

            if (panel === 'candidate') {
              reminderParam = {
                ...reminderParam,
                ...{
                  reminderDate: new Date(moment(reminderDate).format('YYYY-MM-DD')),
                  candidate: formResult.candidate,
                }
              }
            }

            if (panel === 'contact') {
              const found = allContacts.find((i) => i.id === formResult.contact);
              reminderParam = {
                ...reminderParam,
                ...{
                  reminderDate: new Date(moment(reminderDate).format('YYYY-MM-DD')),
                  contact: formResult.contact,
                  client: found.client.id,
                }
              }
            }

            if (panel === 'link-global') {
              reminderParam = {
                ...reminderParam,
                ...{
                  reminderDate: new Date(moment(reminderDate).format('YYYY-MM-DD')),
                }
              }
            }
            
            const result = await createReminder(
              session.authToken,
              reminderParam,
            );

            if (result.data.responseCode === 0) {
              const response = await getDashboard(session.authToken);
              dispatch({ type: "INIT_DASHBOARD", payload: response.data.data });
              handleOnClose();
              message.success(result.data.message);
            }
            else {
              message.error(result.data.message);
            }
            setCreating(false);
          }}>
          {
            creating ? <Icon type="loading" /> : <Icon type="check" />
          }
          Submit
        </Button>
      ]}
      >
      <div>
        {
          initLoading ? (
            <center><Spin spinning={initLoading} indicator={<Icon type="loading" />} />&nbsp;&nbsp;Preparing Data...</center>
          ) : (
            renderPanel()
          )
        }
      </div>
    </Modal>
  );
}

const CreateReminder = Form.create({ name: 'createReminder' })(CreateReminderForm);

export default CreateReminder;


